import React, { useState, useRef, useEffect } from "react";
import DefaultLayout from "../../../layout/vendor/DefaultLayout";
import {
  Container,
  Row,
  Col,
  Form,
  Button,
  Modal,
  InputGroup,
  Card,
  Spinner,
} from "react-bootstrap";
import { FaArrowRight } from "react-icons/fa";
import { AiOutlineCloudUpload } from "react-icons/ai";
import { CiMail } from "react-icons/ci";
import { IoMdCheckmarkCircleOutline } from "react-icons/io";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Success from "../../../components/vendor/Success";
import Footer from "../../../components/Footer";
import { useMutation } from "react-query";
import { Controller, useForm } from "react-hook-form";
import api from "../../../utils/helper";
import { useAlerts } from "../../../context/AlertContext";
import { URLS } from "../../../utils/URL";
import { useIDsContext } from "../../../context/IDsContext";
import { useAuth } from "../../../context/AuthContext";

const AddCollege = () => {
  const location = useLocation();
  const { userID } = useAuth();
  console.log(userID, "userID");
  //const vendorID = location.state.vendorID;
  const college = location.state.college;
  const { vendorID, vendorName } = useIDsContext();
  console.log("selectedVendor:", vendorID, vendorName);
  const isEdit = location.state?.isEdit;
  //const { vendorName } = location.state || {};
  const navigate = useNavigate();
  const [logoFile, setLogoFile] = useState(null);
  const [logoPreview, setLogoPreview] = useState(
    isEdit ? URLS.IMG_URL + college?.profile_img : null
  );
  const [dataToNavigate, setDataToNavigate] = useState({});
  const [signatureFile, setSignatureFile] = useState(null);
  const [signaturePreview, setSignaturePreview] = useState(
    isEdit ? URLS.IMG_URL + college?.signature_img : null
  ); // for image preview
  const signatureInputRef = useRef(null); // to trigger input programmatically
  const { showSuccess, showError } = useAlerts();
  const fileInputRef = useRef(null);
  console.log(vendorID, "location.state");
  console.log(location.state, "location.state");

  const {
    control,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm({
    defaultValues: {
      collegeName: isEdit ? college.name : "",
      location: isEdit ? college.location : "",
      firstName: isEdit ? college.firstname : "",
      lastName: isEdit ? college.lastname : "",
      email: isEdit ? college.email : "",
      password: "",
      sendInvite: false,
    },
  });

  const collegeMutation = useMutation(
    isEdit
      ? (vendorsData) =>
          api.put(`/super-admin/colleges/${college._id}`, vendorsData)
      : (vendorData) => api.post("/super-admin/colleges", vendorData),
    {
      onSuccess: (response) => {
        showSuccess(response.data?.message || "college added successfully!!!");
        console.log("college added successfully!", response);

        setTimeout(() => {
          handleCancel();
        }, 2000);
      },
      onError: (error) => {
        showError(error?.response?.data?.message || "Failed to add vendor: ");
        console.log("Failed to add vendor: " + error.message);
      },
    }
  );

  const logoMutation = useMutation(
    ({ formData }) => api.upload("/upload", formData, "upload"),
    {
      onSuccess: (response, variables) => {
        const updatedFormInputs = {
          ...variables.formInputs,
          profile_img: response?.data?.data?.url,
        };
        collegeMutation.mutate(updatedFormInputs);
        const updatedSignatureFormInputs = {
          ...variables.formInputs,
          signature_img: response?.data?.data?.url,
        };
        collegeMutation.mutate(updatedSignatureFormInputs);
      },
      onError: (error) => {
        showError(error?.response?.data?.message || "Error uploading file:");
        console.error("Error uploading file:", error);
      },
    }
  );

  const handleDivClick = () => {
    fileInputRef.current.click(); // Trigger file input click
  };

  const handleLogoChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setLogoFile(file);
      const reader = new FileReader();
      reader.onload = () => {
        setLogoPreview(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleSignatureChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setSignatureFile(file);
      const reader = new FileReader();
      reader.onload = () => {
        setSignaturePreview(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  useEffect(() => {
    if (isEdit && college) {
      // Other form value initialization logic
      if (college.signature_img) {
        setSignaturePreview(URLS.IMG_URL + college.signature_img); // Set thumbnail preview if in edit mode
      }
    }
  }, [isEdit, college]);

  // const onSubmit = (data) => {
  //   const formInputs = {
  //     vendor: vendorID,
  //     name: data.collegeName,
  //     location: data.location,
  //     firstname: data.firstName,
  //     lastname: data.lastName,
  //     email: data.email,
  //     password: data.password,
  //     sendInvite: data.sendInvite,
  //   };

  //   // For edit mode with existing image that's not being changed
  //   if (isEdit && !logoFile && logoPreview) {
  //     // Extract just the filename from the full URL path
  //     const existingImagePath = vendorID?.profile_img;
  //     formInputs.profile_img = existingImagePath;
  //     collegeMutation.mutate(formInputs);
  //   }
  //   // For new image upload (both in create and edit mode)
  //   else if (logoFile) {
  //     const formData = new FormData();
  //     formData.append("file", logoFile);
  //     formData.append("courseName", "college");
  //     formData.append("moduleName", data.collegeName);

  //     logoMutation.mutate({ formData, formInputs });
  //   }
  //   // For cases with no image (create mode without image)
  //   else {
  //     collegeMutation.mutate(formInputs);
  //   }
  // };

  const handleCancel = () => {
    reset();
    navigate("/vendor/college-list", { state: { vendorID: userID } });
  };

  // Update the onSubmit function to handle both image uploads
  const onSubmit = async (data) => {
    try {
      const formInputs = {
        vendor: vendorID,
        name: data.collegeName,
        location: data.location,
        firstname: data.firstName,
        lastname: data.lastName,
        email: data.email,
        password: data.password,
        sendInvite: data.sendInvite,
      };

      // Retain existing URLs in edit mode if no new files are uploaded
      if (isEdit) {
        if (!logoFile && college.profile_img) {
          formInputs.profile_img = college.profile_img;
        }
        if (!signatureFile && college.signature_img) {
          formInputs.signature_img = college.signature_img;
        }
      }

      // Upload cover image if a new file is provided
      if (logoFile) {
        formInputs.profile_img = await uploadFile(logoFile);
      }

      // Upload thumbnail image if a new file is provided
      if (signatureFile) {
        formInputs.signature_img = await uploadFile(signatureFile);
      }

      // Submit the course data
      if (isEdit) {
        await collegeMutation.mutateAsync(formInputs);
        showSuccess("College updated successfully!");
        navigate("/vendor/college-list", { state: { vendorID: userID } });
      } else {
        const response = await collegeMutation.mutateAsync(formInputs);
        showSuccess("College added successfully!");
        setDataToNavigate(response.data?.data);
        reset();
      }
    } catch (error) {
      showError(
        error.response?.data?.message ||
          "Failed to save course. Please try again."
      );
    }
  };

  const uploadFile = async (file) => {
    const formData = new FormData();
    formData.append("file", file);
    formData.append("courseName", "course");
    formData.append("moduleName", "course");
    const response = await api.upload("/upload", formData, "upload");
    return response.data.data.url;
  };

  return (
    <>
      <DefaultLayout>
        <div className="bgNav d-block d-lg-none pb-5 px-1 position-relative">
          <h2 className="heading mb-0 px-3">
            {/* <Link to="/vendor/colleges" className="linkHref"> */}
            <span className="linkHref">{vendorName}</span>
            {/* </Link>{" "} */}
            <Link to="/vendor/college-list" className="linkHref">
              <span className="linkHref">
                {" "}
                <FaArrowRight /> Colleges
              </span>
            </Link>{" "}
            <span className=" text-light fw-bold">
              {" "}
              <FaArrowRight className="mx-1" /> {isEdit ? "Edit" : "Add New"}
            </span>
          </h2>
        </div>

        <Container
          fluid
          className="main-container mt-0 mt-md-4 ps-auto ps-md-0"
        >
          <Card className="form-card">
            {/* Header Section */}
            <Card.Header className="heading d-none d-lg-block">
              <div className="d-flex justify-content-between align-items-center">
                <div className="d-flex gap-2 align-items-center">
                  <h2 className="text-muted venhead mb-0">
                    {/* <Link to="/vendor/colleges" className="linkHref"> */}
                    <span className="linkHref">{vendorName}</span>
                    {/* </Link>{" "} */}
                    <Link to="/vendor/college-list" className="linkHref">
                      <span>
                        {" "}
                        <FaArrowRight /> Colleges
                      </span>
                    </Link>{" "}
                    <span className="venhead fw-bold">
                      {" "}
                      <FaArrowRight /> {isEdit ? "Edit" : "Add New"}
                    </span>
                  </h2>
                </div>
                <div>
                  <Button
                    variant="outline-secondary"
                    className="me-2 btn-sec"
                    onClick={handleCancel}
                  >
                    Cancel
                  </Button>
                  <Button
                    color="#60B1FF"
                    className="btn-sec"
                    onClick={handleSubmit(onSubmit)}
                    disabled={
                      collegeMutation.isLoading || logoMutation.isLoading
                    }
                  >
                    {collegeMutation.isLoading ||
                      (logoMutation.isLoading && <Spinner size="sm" />)}
                    Save & Invite
                  </Button>
                </div>
              </div>
            </Card.Header>
            <Card.Body className="mobile-form">
              <Row className="mb-3">
                <Col md={3} className="px-4 py-2 p-md-2">
                  <h3 className="vendorDetails">College Details</h3>
                  <p className="basicInfo">
                    {isEdit ? "Update college" : "Add college"}'s basic info
                  </p>
                </Col>
                <Col md={9} className="contentdiv">
                  <Form className="p-2 formMain">
                    {/* Vendor Name */}
                    <Form.Group className="mb-3">
                      <Form.Label>
                        College Name <span className="text-danger">*</span>
                      </Form.Label>
                      <Controller
                        name="collegeName"
                        control={control}
                        rules={{ required: "College name is required" }}
                        render={({ field }) => (
                          <Form.Control
                            {...field}
                            type="text"
                            placeholder="Enter college name"
                            isInvalid={!!errors.collegeName}
                          />
                        )}
                      />
                      {errors.collegeName && (
                        <Form.Control.Feedback type="invalid">
                          {errors.collegeName.message}
                        </Form.Control.Feedback>
                      )}
                    </Form.Group>

                    {/* Upload Logo */}
                    <Form.Group className="mb-3 d-flex justify-content-between uploadProfile">
                      <div className="p-con d-flex gap-4 p-2 w-50">
                        <div>
                          <img
                            src={signaturePreview}
                            className="profile-holder"
                          />
                        </div>
                        <div
                          className="text-center w-100"
                          onClick={() => signatureInputRef?.current?.click()}
                          style={{ cursor: "pointer" }}
                        >
                          <img
                            // src={signaturePreview || "/images/uploadIcon.png"}
                            src="/images/uploadIcon.png"
                            className="icon-upload"
                            alt="Upload"
                          />
                          <p className="upload-text mb-0">
                            <span>Click to upload</span> or drag and drop
                          </p>
                          <p className="mb-0">Signature Image</p>
                          <p className="text-muted upload-text-small mb-0">
                            SVG, PNG, JPG or GIF (max. 400x400px)
                          </p>
                          <Form.Control
                            type="file"
                            accept="image/*"
                            className="d-none"
                            ref={signatureInputRef}
                            onChange={handleSignatureChange}
                          />
                        </div>
                      </div>
                      <div className="p-con d-flex gap-4 p-2 w-50">
                        <div>
                          <img src={logoPreview} className="profile-holder" />
                        </div>
                        <div
                          className="p-con d-flex gap-4 p-2 w-100"
                          onClick={handleDivClick}
                        >
                          <div className="text-center w-100">
                            <img
                              src="/images/uploadIcon.png"
                              className="icon-upload"
                            />
                            <p className="upload-text mb-0">
                              <span>Click to upload</span> or drag and drop
                            </p>
                            <p className="text-muted upload-text-small mb-0">
                              SVG, PNG, JPG or GIF (max. 800x400px)
                            </p>
                            <Form.Control
                              type="file"
                              ref={fileInputRef}
                              onChange={handleLogoChange}
                              accept="image/*"
                              className="d-none"
                            />
                          </div>
                        </div>
                      </div>
                    </Form.Group>

                    {/* Location */}
                    <Form.Group className="mb-3">
                      <Form.Label>
                        Location <span className="text-danger">*</span>
                      </Form.Label>
                      <Controller
                        name="location"
                        control={control}
                        rules={{ required: "Location is required" }}
                        render={({ field }) => (
                          <Form.Control
                            {...field}
                            type="text"
                            placeholder="Enter location"
                            isInvalid={!!errors.location}
                          />
                        )}
                      />
                      {errors.location && (
                        <Form.Control.Feedback type="invalid">
                          {errors.location.message}
                        </Form.Control.Feedback>
                      )}
                    </Form.Group>
                  </Form>
                </Col>
              </Row>

              {/* Admin Details */}
              <Row>
                <Col md={3} className="px-4 py-2 p-md-2">
                  <h3 className="vendorDetails">Admin Details</h3>
                  <p className="basicInfo">Add admin's basic info</p>
                </Col>
                <Col md={9} className="contentdiv">
                  <Form className="p-2 formMain">
                    <Row>
                      <Col md={6}>
                        <Form.Group className="mb-3">
                          <Form.Label>
                            First name <span className="text-danger">*</span>
                          </Form.Label>
                          <Controller
                            name="firstName"
                            control={control}
                            rules={{ required: "First name is required" }}
                            render={({ field }) => (
                              <Form.Control
                                {...field}
                                type="text"
                                placeholder="First name"
                                isInvalid={!!errors.firstName}
                              />
                            )}
                          />
                          {errors.firstName && (
                            <Form.Control.Feedback type="invalid">
                              {errors.firstName.message}
                            </Form.Control.Feedback>
                          )}
                        </Form.Group>
                      </Col>
                      <Col md={6}>
                        <Form.Group className="mb-3">
                          <Form.Label>
                            Last name <span className="text-danger">*</span>
                          </Form.Label>
                          <Controller
                            name="lastName"
                            control={control}
                            rules={{ required: "Last name is required" }}
                            render={({ field }) => (
                              <Form.Control
                                {...field}
                                type="text"
                                placeholder="Last name"
                                isInvalid={!!errors.lastName}
                              />
                            )}
                          />
                          {errors.lastName && (
                            <Form.Control.Feedback type="invalid">
                              {errors.lastName.message}
                            </Form.Control.Feedback>
                          )}
                        </Form.Group>
                      </Col>
                    </Row>

                    <Form.Group className="mb-3">
                      <Form.Label>
                        Email <span className="text-danger">*</span>
                      </Form.Label>
                      <Controller
                        name="email"
                        control={control}
                        rules={{
                          required: "Email is required",
                          pattern: {
                            value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                            message: "Invalid email address",
                          },
                        }}
                        render={({ field }) => (
                          <InputGroup>
                            <InputGroup.Text className="bg-transparent">
                              <CiMail />
                            </InputGroup.Text>
                            <Form.Control
                              {...field}
                              type="email"
                              placeholder="Enter email"
                              isInvalid={!!errors.email}
                              disabled={isEdit} // 👈 disable when editing
                            />
                            {errors.email && (
                              <Form.Control.Feedback type="invalid">
                                {errors.email.message}
                              </Form.Control.Feedback>
                            )}
                          </InputGroup>
                        )}
                      />
                    </Form.Group>

                    {!isEdit && (
                      <Form.Group className="mb-3">
                        <Form.Label>
                          Set Password <span className="text-danger">*</span>
                        </Form.Label>
                        <Controller
                          name="password"
                          control={control}
                          rules={{
                            required: "Password is required",
                            minLength: {
                              value: 8,
                              message: "Password must be at least 8 characters",
                            },
                          }}
                          render={({ field }) => (
                            <Form.Control
                              {...field}
                              type="password"
                              placeholder="Set password"
                              isInvalid={!!errors.password}
                            />
                          )}
                        />
                        {errors.password && (
                          <Form.Control.Feedback type="invalid">
                            {errors.password.message}
                          </Form.Control.Feedback>
                        )}
                      </Form.Group>
                    )}

                    {!isEdit && (
                      <Form.Group className="mb-3">
                        <Controller
                          name="sendInvite"
                          control={control}
                          render={({ field: { value, onChange } }) => (
                            <Form.Check
                              type="switch"
                              id="invite-email-switch"
                              label="Send Invite Email"
                              className="checktoggle"
                              checked={value}
                              onChange={(e) => onChange(e.target.checked)}
                            />
                          )}
                        />
                        <Form.Text className="text-muted">
                          An invitation will be sent to the teacher with login
                          instructions & password.
                        </Form.Text>
                      </Form.Group>
                    )}

                    <div className="d-flex justify-content-end d-lg-none">
                      <Button
                        variant="outline-secondary"
                        onClick={handleCancel}
                      >
                        Cancel
                      </Button>
                      <Button
                        color="#60B1FF"
                        className="ms-2 "
                        onClick={handleSubmit(onSubmit)}
                        disabled={
                          collegeMutation.isLoading || logoMutation.isLoading
                        }
                      >
                        {collegeMutation.isLoading ||
                          (logoMutation.isLoading && <Spinner size="sm" />)}
                        Save & Invite
                      </Button>
                    </div>
                  </Form>
                </Col>
              </Row>
            </Card.Body>
          </Card>
        </Container>
        <div className="d-none d-lg-block">
          <Footer />
        </div>
      </DefaultLayout>
    </>
  );
};

export default AddCollege;
